import { useParams } from "react-router";
import { Chip } from "@/components/Chip";
import { KubernetesRecordingModal } from "./KubernetesRecordingModal";
import { type KubernetesRecordingSummary } from "./kubernetesShared";
import { RecordingsPage } from "./RecordingsPage";

export function KubernetesRecordings() {
  const { orgId } = useParams();

  return (
    <RecordingsPage<KubernetesRecordingSummary>
      path="kubernetes-recordings"
      label="Kubernetes"
      showSize={false}
      searchPlaceholder="Search resource, user or request"
      extraColumn={{
        label: "Requests",
        render: (recording) => (
          <span className="flex items-center gap-2">
            {recording.requestCount}
            {recording.recordingIncomplete && (
              <Chip variant="warning">Partially recorded</Chip>
            )}
          </span>
        ),
      }}
      renderModal={(recording, onClose) =>
        orgId && (
          <KubernetesRecordingModal
            orgId={orgId}
            recordingId={recording.id}
            onClose={onClose}
          />
        )
      }
    />
  );
}
